import { render, staticRenderFns } from "./Improvements.vue?vue&type=template&id=46d563c4&"
import script from "./Improvements.vue?vue&type=script&lang=js&"
export * from "./Improvements.vue?vue&type=script&lang=js&"
import style0 from "./Improvements.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports